import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
const PlaceHolder = ({ placeHolderName, backgroundColor }) => (_jsx(Box, { sx: {
        border: '2px dashed #ccc',
        borderRadius: '0.5em',
        margin: '2px',
        opacity: '.5',
        backgroundColor,
    }, children: _jsx(Typography, { variant: "h4", sx: {
            m: '1em',
        }, children: placeHolderName }) }));
PlaceHolder.defaultProps = {
    backgroundColor: '#fff',
};
export default PlaceHolder;
//# sourceMappingURL=PlaceHolder.js.map